import { render, staticRenderFns } from "./DashboardUsers.vue?vue&type=template&id=d18a9b00"
import script from "./DashboardUsers.vue?vue&type=script&lang=js"
export * from "./DashboardUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports